import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import GiveawaysListLayer from "../../components/Giveaways/GiveawaysListLayer";

const GiveawaysPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Giveaways" />
      <GiveawaysListLayer />
    </MasterLayout>
  );
};

export default GiveawaysPage;
